import { isTabbable } from './is-tabbable.js';

/**
 * Returns the first descendant of the container that the browser reaches when
 * pressing `Tab`, or `null` if there is none. Unlike `getFirstFocusableChild`
 * this skips elements that are not rendered or that are inside an `inert`
 * subtree.
 *
 * @internal
 */
export function getFirstTabbableChild(
  container: HTMLElement | Node,
): Node | null {
  const treeWalker = document.createTreeWalker(container);

  while (treeWalker.nextNode()) {
    if (isTabbable(treeWalker.currentNode)) {
      return treeWalker.currentNode;
    }
  }

  return null;
}
